import { Catalog } from '../registry/catalog.js';
import { ComponentMetadata } from '../registry/component-metadata.js';
function AwesomeComponent(parameters) {
    return function (component) {
        const name = parameters.name ?? component.name;
        const metadata = new ComponentMetadata({
            ...parameters,
            component,
            name,
        });
        Catalog.register(name, metadata);
        if (!Object.prototype.hasOwnProperty.call(component, 'propTypes')) {
            Object.defineProperty(component, 'propTypes', { value: metadata.getPropTypes(), writable: false });
        }
        return component;
    };
}
export { AwesomeComponent, };
//# sourceMappingURL=awesome-component.js.map